import React, { useContext, useMemo } from 'react';
import classes from './PostPreview.module.scss';
import { PostEditorContext } from '../states/PostEditorProvider';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
import classNames from 'classnames';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { PostCardMediaPreviewWrapper } from './PostCardMediaPreviewWrapper';

export const PostPreviewView = (): JSX.Element => {
  const { state, profiles } = useContext(PostEditorContext);
  const [tabsState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = tabsState;
  const selectedPosts = useMemo(() => {
    const group = state.postGroups[postGroupIndex];
    return group.customizeContentPerProfile
      ? typeof group.activeCustomizeIndex === 'number'
        ? [group.posts[group.activeCustomizeIndex]]
        : group.posts
      : group.profiles.map(p => {
          return {
            ...group.groupPostAttributes,
            customizedProfileId: p.profileId
          };
        });
  }, [state, postGroupIndex]);

  return (
    <>
      {selectedPosts.length ? (
        selectedPosts.map((post, index) => (
          <div
            key={`selectedPreviewPost-${post.customizedProfileId}-${post.content.media.length}-${
              post.content.link ? post.content.link.url : 'no-link'
            }`}
            className={classNames(index < selectedPosts.length - 1 ? classes.PostPreviewWrapper : null)}>
            <PostCardMediaPreviewWrapper
              context={'postEditor'}
              post={post}
              profiles={profiles}
              stateProfiles={state.postGroups[postGroupIndex].profiles}
            />
          </div>
        ))
      ) : (
        <BoxNotification type={'warning'}>Once you select a profile, you’ll see a post preview here.</BoxNotification>
      )}
    </>
  );
};
